import request from '../utils/request.js'

// 我的患者列表
export function getUserMemberList(data) {
    return request({
        url: '/user-tracking/wx/userMember/pageMemberList',
        method: 'post',
        data
    })
}

// 该用户的患者
export function getPageMemberListByUserNo(data) {
    return request({
        url: '/user-tracking/wx/userMember/pageMemberListByUserNo',
        method: 'post',
        data
    })
}

// 获取当前用户的信息
export function getUserInfo(data) {
    return request({
        url: '/user-login/wx/userInfo/getUserInfo',
        method: 'get',
        params: data
    })
}

// 检查是否有未读消息
export function checkNoRead() {
    return request({
        url: '/user-tracking/wx/efficacyTrackRemind/checkNoRead',
        method: 'get'
    })
}

// 获取健康管家列表排除自己
export function getDoctorAssistan(data) {
    return request({
        url: '/user-tracking/wx/doctorAssistant/getDoctorAssistantByAssistantNo',
        method: 'post',
        data
    })
}

// 客户关系下拉列表
export function getUserUpholdDropDownBoxAll() {
    return request({
        url: '/user-tracking/wx/userUphold/getDropDownBoxAll',
        method: 'get'
    })
}

// 我的微信用户
export function wxUserInfo(data) {
    return request({
        url: '/user-tracking/wx/userInfo/pageList',
        method: 'post',
        data
    })
}

// 转移微信用户
export function transferUserInfo(data) {
    return request({
        url: '/user-tracking/wx/userInfo/transferUserInfo',
        method: 'post',
        data
    })
}

export function saveUserUphold(data) {
    return request({
        url: '/user-tracking/wx/userInfo/saveUserUphold',
        method: 'post',
        data
    })
}

export function getEnterpriseWechatlist(data) {
    return request({
        url: '/user-tracking/wx/doctorInfo/getEnterpriseWechatlist',
        method: 'post',
        data
    })
}

export function getEnterpriseWechatUserlist(data) {
    return request({
        url: '/user-tracking/wx/userInfo/getEnterpriseWechatUserlist',
        method: 'post',
        data
    })
}

export function userBindingDoctor(data) {
    return request({
        url: '/user-tracking/wx/userInfo/userBindingDoctor',
        method: 'post',
        data
    })
}

export function userUnbindingDoctor(data) {
    return request({
        url: '/user-tracking/wx/userInfo/userUnbindingDoctor',
        method: 'post',
        data
    })
}

export function getDoctorDropDownBox() {
    return request({
        url: '/doctor-service/efficacy/doctorInfo/getAllDoctorDropDownBox',
        method: 'get'
    })
}


export function updateDoctorOfAsk(data) {
    return request({
        url: '/user-service/doctormg/askinfo/transferDoctor',
        method: 'post',
        data
    })
}

// 待响应用户
export function getCorrespondingList(data) {
    return request({
        url: '/user-service/userInfo/stayRespondPage',
        method: 'post',
        data
    })
}


//会诊管理
export function getPageConsultationList(data) {
    return request({
        url: '/doctor-service/doctorConsultation/pageList',
        method: 'post',
        data
    })
}


//绑定渠道
export function bindChannel(data) {
    return request({
        url: '/marketing-service/wxuser/bindChannel',
        method: 'post',
        data
    })
}

//获取渠道信息
export function getChannelInfo(code) {
    return request({
        url: `/marketing-service/channel/inviteCode/${code}`,
        method: 'get',
    })
}

//我的-专属医生
export function getPageDoctorsList(data) {
    return request({
        url: '/doctor-service/doctor/list',
        method: 'post',
        data
    })
}

//我的-通过ids获取工作室
export function getStudios(data) {
    return request({
        url: `/marketing-channel/channel/studio/v2?ids=${data.ids}`,
        method: 'get',
    })
}

//我的-获取channelId
export function getStaffSchedule(data) {
    return request({
        url: `/doctor-service/schedule/getStaffSchedule?date=${data.date}&staffNo=${data.staffNo}`,
        method: 'get',
    })
}

//我的-获取工作室信息
export function getStudioInfo(data) {
    return request({
        url: `/marketing-channel/channel/studio/${data.id}`,
        method: 'get',
    })
}

//我的-修改工作室信息
export function updateStudioInfo(data) {
    return request({
        url: `/marketing-channel/channel/studio/update`,
        method: 'post',
        data
    })
}

//我的-获取工作室视频咨询记录
export function videoConsultationRecord(data) {
    return request({
        url: `/user-service/app/userVideoConsultationRecord/page`,
        method: 'post',
        data
    })
}

//商品订单列表
export function getGoodsOrderList(data) {
    return request({
        url: `/order-service/app/order/getGoodsOrderList?pageNo=${data.pageNo}&pageSize=${data.pageSize}&assistantNo=${data.assistantNo}&q=${data.q}`,
        method: 'get',
    })
}
//商品订单详情
export function getGoodsOrderDetail(orderId) {
    return request({
        url: `/order-service/app/order/getGoodsOrderDetail?orderId=${orderId}`,
        method: 'get',
    })
}
//药品订单列表
export function getDrugOrderList(data) {
    return request({
        url: `/order-service/order/itemList/v2`,
        method: 'post',
        data
    })
}

//药品订单详情
export function getDrugOrderDetail(data) {
    return request({
        url: `/order-service/order/itemDetail?orderNo=${data.orderNo}&status=${data.status}`,
        method: 'get',
    })
}
